import { render, staticRenderFns } from "./LimitedTimeRulePopup.vue?vue&type=template&id=10595d7e&scoped=true&"
import script from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeRulePopup.vue?vue&type=style&index=0&id=10595d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10595d7e",
  null
  
)

export default component.exports